import { useAppI18N } from '@/app'
import { View, Text, Button } from '@/components'
import { modal } from '@codeleap/modals'

/** Shown when a picked picture is past `MAX_UPLOAD_PIXELS` — see `uploadBounds.ts`. */
export const ImageTooLargeAlert = modal()
  .content(props => {
    const { toggle } = props

    const { t } = useAppI18N()

    return (
      <View variants={['column', 'gap:2', 'center']}>
        <Text variants={['h4', 'color:neutral10']} text={t('imageTooLarge.title')} />
        <Text variants={['p1', 'textCenter']} text={t('imageTooLarge.body')} />
        <Button
          onPress={toggle}
          text={t('imageTooLarge.ok')}
          debugName={'image too large alert ok'}
          variants={['destructive', 'fullWidth']}
        />
      </View>
    )
  })
  .props({ variants: ['centered'], showClose: false })
